import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const LockIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.112 9.032V7.016C15.112 6.472 14.972 5.96 14.692 5.48C14.412 5 14.032 4.62 13.552 4.34C13.072 4.06 12.56 3.92 12.016 3.92C11.472 3.92 10.96 4.06 10.48 4.34C10 4.62 9.62 5 9.34 5.48C9.06 5.96 8.92 6.472 8.92 7.016V9.032H15.112ZM12.016 18.032C12.56 18.032 13.032 17.832 13.432 17.432C13.832 17.032 14.032 16.56 14.032 16.016C14.032 15.472 13.832 15 13.432 14.6C13.032 14.2 12.56 14 12.016 14C11.472 14 11 14.2 10.6 14.6C10.2 15 10 15.472 10 16.016C10 16.56 10.2 17.032 10.6 17.432C11 17.832 11.472 18.032 12.016 18.032ZM18.016 9.032C18.56 9.032 19.032 9.224 19.432 9.608C19.832 9.992 20.032 10.456 20.032 11V21.032C20.032 21.576 19.832 22.04 19.432 22.424C19.032 22.808 18.56 23 18.016 23H6.016C5.472 23 5 22.808 4.6 22.424C4.2 22.04 4 21.576 4 21.032V11C4 10.456 4.2 9.992 4.6 9.608C5 9.224 5.472 9.032 6.016 9.032H7V7.016C7 6.104 7.224 5.264 7.672 4.496C8.12 3.728 8.728 3.12 9.496 2.672C10.264 2.224 11.104 2 12.016 2C12.928 2 13.768 2.224 14.536 2.672C15.304 3.12 15.912 3.728 16.36 4.496C16.808 5.264 17.032 6.104 17.032 7.016V9.032H18.016Z'
                fill='currentColor'
            />
        </>
    ),
})

LockIcon.displayName = 'LockIcon'
